import { render } from "./login-three.vue?vue&type=template&id=1bffa5cf"
import script from "./login-three.vue?vue&type=script&lang=js"
export * from "./login-three.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__